/* Slider Halskæde guldbelagt — mobil-galleri.
 *
 * Rækkefølge på mobil (<=699 px), 7 medier:
 *   1. video          uændret
 *   2. hvid skjorte   NY — kvadratisk, uden tekst
 *   3. packshot       diagonal
 *   4. mørk hud
 *   5. Rosa UGC       NY — uden musik, autoplay uden knapper
 *   6. brun blazer
 *   7. gaveæske
 *
 * Ude af mobil-galleriet: image_64 (vådt hår), packshot_19_guld (lodret
 * packshot, fortsat produktets featured media) og nyt.png (solbriller).
 *
 * Desktop (>=700 px) er urørt: alt afmonteres og den oprindelige rækkefølge
 * sættes tilbage. Produktmedier og featuredMedia ændres ikke.
 */
(() => {
  const CFG = window.PKM_SLIDER_PDP;
  if (!CFG) return;

  const params = new URLSearchParams(location.search);
  if (params.get('pdp') === 'off') return;

  const MOBILE = matchMedia('(max-width: 699px)');

  // Mediernes id'er på Slider Halskæde Guldbelagt (9971886424406)
  const M = {
    video: '55988133757270',
    diagonal: '64670335598934',
    darkSkin: '64625091707222',
    brownBlazer: '64624841261398',
    giftBox: '56349894574422',
  };

  const cropKey = (params.get('crop') || 'b').toLowerCase();
  const SHIRT = (CFG.shirt && (CFG.shirt[cropKey] || CFG.shirt.b)) || null;
  const ROSA = CFG.rosa || null;
  if (!SHIRT || !ROSA) return;

  const ORDER = [
    M.video,
    'shirt',
    M.diagonal,
    M.darkSkin,
    'rosa',
    M.brownBlazer,
    M.giftBox,
  ];

  let state = null;

  const findGallery = () =>
    document.querySelector('product-gallery[data-pkm-slider-product-metal="gold"]');

  /* ---------- de to nye slides ---------- */

  function buildShirtSlide(template) {
    // Klon en billed-slide, så al tema-CSS og struktur arves.
    const slide = template.cloneNode(true);
    slide.dataset.mediaId = 'pkm-shirt';
    slide.dataset.pkmSliderSlide = 'shirt';
    const img = slide.querySelector('img');
    if (!img) return null;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.removeAttribute('fetchpriority');
    img.src = SHIRT.src;
    img.width = 2000;
    img.height = 2000;
    img.alt = SHIRT.alt || '';
    img.loading = 'lazy';
    return slide;
  }

  function buildRosaSlide(template) {
    // Galleriets egen højde bevares, 4 % af kildens top og bund skæres væk,
    // og siderne fyldes af en sløret, bevægelig baggrund tegnet fra videoen
    // selv. Ingen knapper: den spiller, når den er på skærmen.
    const slide = template.cloneNode(false);
    slide.dataset.mediaId = 'pkm-rosa';
    slide.dataset.mediaType = 'video';
    slide.dataset.pkmSliderSlide = 'rosa';
    slide.innerHTML =
      '<div class="pkm-slider-film">' +
      '<canvas width="320" height="320" aria-hidden="true"></canvas>' +
      '<video class="pkm-slider-film__video" muted playsinline loop autoplay' +
      ' preload="metadata" disableremoteplayback' +
      ' aria-label="' + (ROSA.alt || '') + '"' +
      ' poster="' + ROSA.poster + '" src="' + ROSA.src + '"></video>' +
      '</div>';

    const box = slide.querySelector('.pkm-slider-film');
    const video = box.querySelector('video');
    const canvas = box.querySelector('canvas');
    const ctx = canvas.getContext('2d');

    video.muted = true;               // filen har intet lydspor — bælte og seler
    let raf = 0;
    let visible = false;

    function size() {
      const rect = box.getBoundingClientRect();
      if (!rect.height) return;
      const scaled = rect.height / 0.92;               // 4 % top + 4 % bund
      video.style.setProperty('--pkm-w', (scaled * 1080) / 1920 + 'px');
      video.style.setProperty('--pkm-h', scaled + 'px');
      canvas.height = Math.round((320 * rect.height) / Math.max(1, rect.width));
    }

    function draw() {
      if (video.readyState >= 2 && video.videoWidth) {
        const s = Math.max(
          canvas.width / video.videoWidth,
          canvas.height / video.videoHeight
        );
        const w = video.videoWidth * s;
        const h = video.videoHeight * s;
        ctx.drawImage(video, (canvas.width - w) / 2, (canvas.height - h) / 2, w, h);
      }
      if (!video.paused) raf = requestAnimationFrame(draw);
    }

    video.addEventListener('loadeddata', draw);
    video.addEventListener('play', () => {
      cancelAnimationFrame(raf);
      draw();
    });
    video.addEventListener('pause', () => cancelAnimationFrame(raf));

    // media-carousel forventer, at første barn i en video-slide har play() og
    // pause() — `_onMediaSettled` pauser hver video-slide og kalder play() på
    // den valgte. Uden dem kaster temaet på hvert slide-skift. Vi opfylder
    // kontrakten i stedet for at omgå den, så carousel'en styrer afspilningen
    // præcis som for produktvideoen.
    let stoppedByCarousel = false;
    box.pause = () => {
      stoppedByCarousel = true;
      video.pause();
    };
    box.play = () => {
      stoppedByCarousel = false;
      return video.play().catch(() => {});
    };

    // Sekundær sikring: pause når galleriet er scrollet helt ud af skærmen.
    const io = new IntersectionObserver(
      (entries) => {
        visible = entries[0].isIntersecting;
        if (!visible) video.pause();
        else if (!stoppedByCarousel) video.play().catch(() => {});
      },
      { threshold: 0.4 }
    );
    const ro = new ResizeObserver(size);
    function onVisibility() {
      if (document.hidden) video.pause();
      else if (visible && !stoppedByCarousel) video.play().catch(() => {});
    }

    slide._pkmStart = () => {
      io.observe(box);
      ro.observe(box);
      document.addEventListener('visibilitychange', onVisibility);
      size();
      video.play().catch(() => {});
    };
    slide._pkmStop = () => {
      video.pause();
      video.removeAttribute('src');
      video.load();
      cancelAnimationFrame(raf);
      io.disconnect();
      ro.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
    };
    return slide;
  }

  /* ---------- prikker og tæller ----------
     Indikatoren er server-renderet med én prik pr. medie og et samlet tal.
     Når mobil-galleriet går fra 8 til 7, skal den overskydende prik ud og
     totalen ned, ellers peger sidste prik på en slide der ikke findes. */

  function setIndicator(count) {
    const ind = document.querySelector('[data-pkm-v4-gallery-indicator]');
    if (!ind) return null;
    const before = {
      count: ind.dataset.mediaCount,
      hidden: [],
    };
    const dots = [...ind.querySelectorAll('[data-pkm-v4-gallery-dot]')];
    dots.forEach((dot, i) => {
      if (i >= count && !dot.hidden) {
        dot.hidden = true;
        before.hidden.push(dot);
      }
    });
    ind.dataset.mediaCount = String(count);
    const total = ind.querySelector('[data-pkm-v4-gallery-total]');
    if (total) {
      before.total = total.textContent;
      total.textContent = String(count);
    }
    return { ind, before, total };
  }

  function restoreIndicator(saved) {
    if (!saved) return;
    saved.before.hidden.forEach((dot) => (dot.hidden = false));
    saved.ind.dataset.mediaCount = saved.before.count;
    if (saved.total && saved.before.total !== undefined) {
      saved.total.textContent = saved.before.total;
    }
  }

  /* ---------- montering ---------- */

  function mount() {
    if (state || !MOBILE.matches) return;
    const gallery = findGallery();
    const carousel = gallery && gallery.querySelector('media-carousel');
    if (!carousel) return;

    const slides = [...carousel.querySelectorAll(':scope > .product-gallery__media')];
    if (slides.length < ORDER.length) return;

    const byId = new Map(slides.map((s) => [s.dataset.mediaId, s]));
    const imageTemplate = slides.find((s) => s.dataset.mediaType === 'image');
    if (!imageTemplate) return;

    const shirt = buildShirtSlide(imageTemplate);
    const rosa = buildRosaSlide(imageTemplate);
    if (!shirt || !rosa) return;

    const next = ORDER.map((key) =>
      key === 'shirt' ? shirt : key === 'rosa' ? rosa : byId.get(key)
    );
    if (next.some((s) => !s)) return;                 // et medie mangler — rør ingenting

    const dropped = slides.filter((s) => !next.includes(s));
    state = {
      carousel,
      originalOrder: slides,
      dropped,
      added: [shirt, rosa],
      placeholders: dropped.map(() => document.createComment('pkm-slider-pdp')),
      indicator: null,
    };

    dropped.forEach((s, i) => s.replaceWith(state.placeholders[i]));

    const frag = document.createDocumentFragment();
    next.forEach((s) => frag.appendChild(s));
    carousel.appendChild(frag);

    state.indicator = setIndicator(next.length);
    rosa._pkmStart();
    gallery.dataset.pkmSliderPdp = 'on';
    resetCarousel(carousel);
  }

  function unmount() {
    if (!state) return;
    const { carousel, originalOrder, dropped, added, placeholders, indicator } = state;
    added.forEach((s) => {
      if (s._pkmStop) s._pkmStop();
      s.remove();
    });
    placeholders.forEach((c, i) => c.replaceWith(dropped[i]));
    const frag = document.createDocumentFragment();
    originalOrder.forEach((s) => frag.appendChild(s));
    carousel.appendChild(frag);
    restoreIndicator(indicator);
    const gallery = findGallery();
    if (gallery) delete gallery.dataset.pkmSliderPdp;
    state = null;
    resetCarousel(carousel);
  }

  function resetCarousel(carousel) {
    // media-carousel cacher sine slides i _items og genberegner dem kun,
    // når cachen er tom (`this._items = this._items || Array.from(children)`).
    // Uden denne nulstilling regner tælleren videre på den gamle liste og
    // viser et forkert nummer efter omrokeringen.
    try {
      carousel._items = null;
      carousel._selectedIndex = 0;
    } catch (e) {
      /* komponenten har ændret sig — swipe retter stadig visningen */
    }
    try {
      if (typeof carousel.select === 'function') carousel.select(0, { animate: false });
      else carousel.scrollTo({ left: 0, behavior: 'auto' });
    } catch (e) {
      carousel.scrollTo({ left: 0, behavior: 'auto' });
    }
    carousel.dispatchEvent(new Event('scroll'));
  }

  function sync() {
    if (MOBILE.matches) mount();
    else unmount();
  }

  MOBILE.addEventListener('change', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(sync, 0));
  } else {
    setTimeout(sync, 0);
  }
  // Galleriet er et custom element — prøv igen indtil det er hydreret.
  let tries = 0;
  const retry = setInterval(() => {
    if (state || ++tries > 20) return clearInterval(retry);
    sync();
  }, 250);
})();
